import { render, staticRenderFns } from "./EvidenceSubmissionList.vue?vue&type=template&id=f05199ba&"
import script from "./EvidenceSubmissionList.vue?vue&type=script&lang=js&"
export * from "./EvidenceSubmissionList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports